import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { managerTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig } from '@/libraries/react-query';
import { managerMutationToasts } from '@/utils/managerMutationToasts';

const TOAST_ID = 'set-manager-password';

export const setManagerPassword: managerTypes.SetManagerPassword = (data) => {
  return axios.put(`/manager/password`, data);
};

type UseSetManagerPasswordOptions = {
  config?: MutationConfig<typeof setManagerPassword>;
};

export function useSetManagerPassword({ config = {} }: UseSetManagerPasswordOptions = {}) {
  return useMutation({
    ...config,
    onMutate: (...args) => {
      managerMutationToasts.loading(TOAST_ID, 'Updating password...');
      config.onMutate?.(...args);
    },
    onSuccess: (...params) => {
      managerMutationToasts.success(TOAST_ID, 'Password updated successfully');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      managerMutationToasts.error(TOAST_ID, serverMessage);
      config.onError?.(error, ...args);
    },
    mutationFn: setManagerPassword,
  });
}
